import {TimeSpentReminderWithBalancePresenter} from "../time-spent-reminder-with-balance-presenter";
import {UserController_GetRealityCheckDataResponse} from "../../../../api/api.service";
import {ShowTimeSpentReminderWithBalanceOptions} from "../../../../specific-dialogs/specific-dialogs.service.interface";

export class MaltaRealityCheckPresenter extends TimeSpentReminderWithBalancePresenter {
    protected async _createTimeSpentReminderWithBalanceOptions(realityCheckData: UserController_GetRealityCheckDataResponse, onDialogClosed: () => void): Promise<ShowTimeSpentReminderWithBalanceOptions> {
        let options = await super._createTimeSpentReminderWithBalanceOptions(realityCheckData, onDialogClosed);
        return {
            ...options,
            amountWagered: realityCheckData.WagerAmount ?? 0,
            subtitle: "TSR_SUBTITLE_MALTA"
        };
    }
}